export const THEME_PREVIEW_KEY = 'cfsf_theme_preview';
export const THEME_PREVIEW_CLASS = 'cfsf-theme-preview';

export function isThemePreviewOn() {
  try {
    return localStorage.getItem(THEME_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function applyThemePreview(on) {
  if (typeof document === 'undefined') {
    return;
  }
  document.body.classList.toggle(THEME_PREVIEW_CLASS, Boolean(on));
}

export function setThemePreview(on) {
  const enabled = Boolean(on);
  try {
    if (enabled) {
      localStorage.setItem(THEME_PREVIEW_KEY, '1');
    } else {
      localStorage.removeItem(THEME_PREVIEW_KEY);
    }
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
  applyThemePreview(enabled);
  return enabled;
}
